import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/Login/LoginPage.js';
import RegistrationPage from './components/SignUp/RegistrationPage.js';
import MfaVerification from './components/Mfa/mfa.js';
import LandingPage from './components/LandingPage/LandingPage.js';
import { useState, useMemo, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';
import TreeGraphRender from './components/LandingPage/TreeGraph/TreeGraphRender.js';
import PrivateRoute from './components/PrivateRoute.js';
import ForgotPassword from './components/ForgetPassword/ForgetPassword.js';
import VerifyEmailPage from './components/Mfa/VerifyEmailPage.js';
import SummaryPage from './components/SummaryView/Summary.js';
import FAQ from './components/Intro/Help/index.js';
import DisclaimerModal from './components/DisclaimerModal/index.js';
import AnalyticsTable from './components/AnalyticsPage/index.js';
import AdminRoute from './components/AdminRoute.js';
import Unauthorized from './components/Unauthorized.js';
import MaintenancePage from './components/Maintainance.js';
import AdminDashboard from './components/AdminDashboard/index.js';
import { FooterContext } from './store/FooterContext.js';
import PaywallRoute from './PaywallRoute.js';
import "./App.css";
import SalesContact from './components/Intro/SalesContact/index.js';


Amplify.configure(awsConfig);

function App() {
  const [footerData, setFooterData] = useState({});

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await fetch("https://5549ucvkb3.execute-api.us-east-2.amazonaws.com");
        const data = await res.json();

        const body = typeof data.body === "string"
          ? JSON.parse(data.body)
          : data;

        if (body.footer) {
          setFooterData(body.footer);
        }

      } catch (err) {
        console.error("Footer Fetch Error:", err);
      }
    };

    fetchFooter();
  }, []);

  const contextValue = useMemo(() => ({
    footerData,
    setFooterData
  }), [footerData]);

  return (
    <Router>
      <FooterContext.Provider value={contextValue}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/signup" element={<RegistrationPage />} />
          <Route path="/mfa" element={<MfaVerification />} />
          <Route path="/help" element={<FAQ />} />
          <Route path="/help/:username" element={<FAQ />} />
          <Route path="/sales" element={<SalesContact />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/forget-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<DisclaimerModal />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/error" element={<MaintenancePage />} />


          {/* All protected routes inside one PrivateRoute wrapper */}
          <Route element={<PrivateRoute />}>
            <Route path="/glue-dashboard" element={<LandingPage />} />
            <Route path="/graph/:glue_id/*" element={
              <PaywallRoute>
                <TreeGraphRender />
              </PaywallRoute>} />
            <Route path="/summary/:glue_id/*" element={<SummaryPage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/analytics" element={<AnalyticsTable />} />
            </Route>
          </Route>
        </Routes>
      </FooterContext.Provider>
    </Router>

  );
}

export default App;
